const calculateUnknownValue = (x, z, y) => y * z / x;

const handleMultiplierValues = ({$multiplierElement, $valuesElements, step, min, max}) => {
  const oldAmount = Number($multiplierElement.innerHTML);
  const newAmount = oldAmount + step;

  if (newAmount < min || newAmount > max) {
    return;
  }

  $valuesElements.forEach($element => {
    const oldValue = Number($element.dataset.value);
    const newValue = calculateUnknownValue(oldAmount, newAmount, oldValue);
    const newShownValue = parseFloat(newValue.toFixed(2));

    if (newValue) {
      $element.innerHTML = newShownValue;
      $element.setAttribute('data-value', newValue);
    }
  });

  $multiplierElement.innerHTML = newAmount;
};

export default function initCounter({min, max, step, $container}) {
  const $multiplierElement = $container.querySelector('.js-multiplier');
  const $valuesElements = $container.closest('.js-main-wrapper').querySelectorAll('.js-counter-value');

  $container.addEventListener('click', e => {
    if (e.target.classList.contains('js-multiplier-button')) {
      const stepValue = parseInt(e.target.dataset.multiplierButton + step, 10);

      handleMultiplierValues({
        step: stepValue,
        $multiplierElement,
        $valuesElements,
        min,
        max
      });
    }
  });
}
